import React from 'react'
import { Box, Typography } from '@mui/material'
import Modal from 'src/ui/Modal/Modal'
import { OrderDetails } from 'src/common/api'
import { ChainName, CHAIN_NATIVE_TOKEN } from 'src/common/static'
import * as S from './styles'

export interface CancelOrderModalProps {
  open: boolean
  order: OrderDetails | null
  onClose: () => void
  onConfirm: () => void
}

const CancelOrderModal: React.FC<CancelOrderModalProps> = ({ open, order, onClose, onConfirm }) => {
  if (!order) return null

  const orderType = order.type === 'MINT' ? 'Mint' : 'Burn'
  const asset = order.transactions[0]?.asset || 'N/A'
  const chain = order.transactions[0]?.chain ? CHAIN_NATIVE_TOKEN[order.transactions[0].chain as ChainName] : 'N/A'
  const amount = `$${order.fiatAmount} ${order.fiatCurrency}`

  return (
    <Modal open={open} onClose={onClose} title="Confirm Order Cancellation" maxWidth="xs">
      <Box sx={{ pt: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please Confirm that you are cancelling the following order
        </Typography>

        <S.DetailContainer>
          <S.DetailRow>
            <S.DetailLabel>Order Type</S.DetailLabel>
            <S.DetailValue>{orderType}</S.DetailValue>
          </S.DetailRow>

          <S.DetailRow>
            <S.DetailLabel>Asset</S.DetailLabel>
            <S.DetailValue>{asset}</S.DetailValue>
          </S.DetailRow>

          <S.DetailRow>
            <S.DetailLabel>Chain</S.DetailLabel>
            <S.DetailValue>{chain}</S.DetailValue>
          </S.DetailRow>

          <S.DetailRow>
            <S.DetailLabel>Amount</S.DetailLabel>
            <S.DetailValue>{amount}</S.DetailValue>
          </S.DetailRow>
        </S.DetailContainer>

        <S.ConfirmButton fullWidth variant="contained" onClick={onConfirm}>
          Confirm
        </S.ConfirmButton>

        <S.NoteText variant="caption" align="center" sx={{ display: 'block', mt: 2 }}>
          Please note this action is{' '}
          <Box component="span" sx={{ fontWeight: 600 }}>
            irreversible
          </Box>
        </S.NoteText>
      </Box>
    </Modal>
  )
}

export default CancelOrderModal
